module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/area_sola-5c0aedc93ef30cddaebbde91cc69d042.jpg";